<template>

       <el-form class="form"  :inline="true">
              <slot>
                    
              </slot>
             <el-form-item v-for="(list,i) in filterList" :key="i" v-if="list.value&&i!=0" :label="list.text+'：'" style="height:40px">
               <el-input v-if="list.type=='text'" v-model.trim="list.value" style="width:170px;" placeholder="请输入"></el-input>
                <el-select v-if="list.type=='select'||list.type=='radio'" v-model="list.value" :multiple="list.multiple"   placeholder="请选择" style="width:170px;">
                  <el-option
                    v-for="item in list.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
                  <el-date-picker v-if="list.type=='timer'&&list.options.length>0" style="width:170px;"
                    v-model="list.value"
                    type="date"
                    placeholder="选择日期">
                  </el-date-picker>
                  <CiicTreeSelect v-if="list.type=='treeSelect'&&list.options.length>0" :name="list.name" :options="list.options" @getValue="selectGroup"
									 :props="defaultGroupProps" :value="list.value" :multiple="false"  :expand="true" :showFilter="false"></CiicTreeSelect>
                <!-- <el-radio v-if="list.type=='radio'" v-model="list.value" v-for="item in list.options" :label="item.value">{{item.label}}</el-radio> -->

            </el-form-item>
          </el-form>
      
</template>

<script>
	import CiicTreeSelect from "@/components/ciic/ciic-tree-select/ciic-tree-select";
  export default {
    name: "sbs-filter-form",
		components: {
			CiicTreeSelect
		},
    props: {
        filterList: {
            type: Array,
            default: [],
        },
			
    },
		methods:{
			selectGroup(val,title,name){
				for(var i=0;i<this.filterList.length;i++){
					if(this.filterList[i].name==name){
						this.filterList[i].value = val;
					}
				}
				this.$emit('update:filterList1',this.filterList);
			}
		},
    data() {
      return {
         defaultGroupProps: {
         	children: 'children',
         	label: 'label',
         	value: 'value',
         },
      };
    }
  };
</script>

<style scoped >
       
   .form >>> .el-form-item{
      margin-right:40px;
      margin-bottom:0;
    }
</style>
